var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveSensor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_258_60805",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 20,
    height: 20,
    transform: "rotate(-90 0 20)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_258_60805)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 10.625L13.3333 10.625L13.3333 9.375L17.0833 9.375L17.0833 10.625ZM14.8029 4.10416L12.1619 6.76604L11.2708 5.875L13.9327 3.23395L14.8029 4.10416ZM14.8029 15.8958L13.9327 16.766L11.2708 14.125L12.1619 13.234L14.8029 15.8958ZM6.57041 13.4904L7.55603 13.1602C7.6095 13.1388 7.65089 13.1068 7.6802 13.0642C7.70964 13.0214 7.72437 12.9733 7.72437 12.9198L7.72436 7.08021C7.72436 7.02673 7.70964 6.97861 7.6802 6.93583C7.65089 6.89319 7.6095 6.86118 7.55603 6.83979L6.57041 6.50958L6.57041 13.4904ZM8.97437 12.9198C8.97437 13.2435 8.88006 13.5366 8.69145 13.799C8.50284 14.0612 8.25367 14.2452 7.94395 14.351L6.57041 14.8077L6.57041 15.5769C6.57041 15.9924 6.42325 16.3474 6.12895 16.6419C5.83464 16.9362 5.47971 17.0833 5.06416 17.0833L2.91666 17.0833L2.91666 2.91666L5.06416 2.91666C5.47971 2.91666 5.83464 3.06382 6.12895 3.35812C6.42325 3.65257 6.57041 4.00757 6.57041 4.42312L6.57041 5.19229L7.9952 5.74208C8.28256 5.85639 8.51756 6.03903 8.7002 6.29C8.88298 6.54111 8.97436 6.82423 8.97437 7.13937L8.97437 12.9198Z",
    fill: "#155DFC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSensor);
export default __webpack_public_path__ + "static/media/Active Sensor.5670c08cb064979b89f50fb1ba6f791e.svg";
export { ForwardRef as ReactComponent };